module.exports = __webpack_public_path__ + "static/aws-61ce03e4530eff2a984dcc1822b0564f.svg";